import { licenseDisplayName, type LicenseRow } from '../../types/onboarding'

/** Unique licensee display names from individual and business license rows, plus any in-use values. */
export function licenseeNameOptionsFromLicenses(
  licenses: LicenseRow[],
  currentValues: (string | undefined)[],
): string[] {
  const fromLicenses = licenses
    .map((l) => licenseDisplayName(l).trim())
    .filter((name) => name.length > 0 && name !== '(Unnamed)')
  const extras = currentValues
    .map((v) => (v ?? '').trim())
    .filter((v): v is string => v.length > 0)
  return Array.from(new Set(fromLicenses.concat(extras))).sort((a, b) =>
    a.localeCompare(b, undefined, { sensitivity: 'base' }),
  )
}
